export default __webpack_public_path__ + "static/media/iPhone-Premium-7.cd42ecc4.png";